import { h, } from "preact";

import { Badge, Button, Tooltip } from "@mui/material";


const WithBadge = ({ badge, ...rest }) => {
    //console.log("withbadge", badge)
    if (badge) return <Badge
        color="primary"
        //variant="dot"
        invisible={false}
        badgeContent=" "
    >
        <TTButton {...rest} />
    </Badge>

    return <TTButton {...rest} />
}

const TTButton = ({ tooltip, icon, onclick_cb }) => {
    if (tooltip) return <Button
        variant="outlined"
        //	color="primary"
        style="color: black; border-color: black;"
        onClick={onclick_cb}
    >
        <Tooltip title={tooltip}>{icon}</Tooltip>
    </Button>
    return <Button
        variant="outlined"
        //	color="primary"
        style="color: black; border-color: black;"
        onClick={onclick_cb}
    >
        {icon}
    </Button>
}

export default function ButtonWithTooltipAndBadge(props) {

    return (
        <WithBadge {...props} />
    );
}